// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1465":"f5cf3357","7850":"8fc2411f","9910":"a4634e51"}[chunkId] || chunkId) + "." + {"1465":"abf85a0254a9c6fa","2619":"495e651e53bbb557","5589":"a352be75f4d0f6ae","5966":"e540edd6b7bbed58","7850":"9a8acfcc17d3c139","8358":"298ada4270c1c410","9910":"f3ab0a076eb6dc08"}[chunkId] + ".js";
};